import soundEffects from '../../services/sounds/soundEffects';

import styles from './Buttons.module.scss';
import type { IBlackButtonProps } from './buttonTypes';

export default function BlackButton({ onClick, withCrown, children, ...rest }: IBlackButtonProps) {
  const classes = ['animation-popup', styles.blackButton];

  if (withCrown) {
    classes.push(styles.withCrown);
  }

  const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);
    soundEffects.playSound('click');
  };

  return (
    <button {...rest} className={classes.join(' ')} onClick={handleOnClick}>
      {children}
    </button>
  );
}
